<template>
	<v-row class="ma-0" v-if="!$store.getters.progress">
		<v-col class="pa-0">
            <v-tabs
				class="fill-height"
                :height="34"
                background-color="background-1"
                slider-color="primary">
                <v-tab :key="1" ripple>DDT di Vendita</v-tab>

                <v-tab-item :key="1" class="pb-offset background-1">

                    <show
                        :id="id"
                        :models="models"
                        :infos="infos"
						topClass="mx-0 pt-2"
                    ></show>

                    <v-col class="pa-0">
						<v-card class="flex pa-0 background-2 round-card">
                			<v-card-title class="pa-3">
				    			<p class="pl-2 pl-xl-3">{{ customerReturn ? 'Dati DDT di reso da cliente' : 'Dati DDT di Reso' }}</p>
								<v-spacer></v-spacer>
                			</v-card-title>        
							<v-divider></v-divider>
							<v-container class="pt-3" fluid>
								<fields-generator
									:fieldsset.sync="fieldsset"
									:model="saleddt"
									ref="fieldsgenerator"
									:selectChange="onChange"
								></fields-generator>
								<small class="pl-4">* Indica i campi obbligatori</small>
							</v-container>
						</v-card>
					</v-col>

					<v-col class="pa-0 pt-4" v-if="relations.products.collection">
						<v-card class="flex pa-0 background-2 round-card">
                			<v-card-title class="pa-3">
				    			<p class="pl-2 pl-xl-3">Conversione Prodotti</p>
								<v-spacer></v-spacer>
								<v-switch
									inset
									style="padding-top: 0; margin: auto"
									label="Converti tutto"
									v-model="processAll"
									hide-details
									color="primary"
								></v-switch>
                			</v-card-title>
							<v-divider></v-divider>
							<v-container class="pa-0" fluid>
								<v-row class="ma-0 pt-0">
									<v-col cols="12" class="pa-0">
										<v-card class="flex background-2" elevation="0">
											<v-data-table
												class="background-2 no-max-height"
												:headers="relations.products.info.fieldDefs"
												:items="relations.products.collection"
												hide-default-footer
												disable-pagination
												item-key="id"
												show-expand>
												<template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
													<tr>
														<template v-for="(header, h) in headers">
															<td v-if="header.value == 'data-table-expand'" :key="'expand-'+h">
																<v-btn
																	v-if="item.description"
																	icon
																	small
																	@click.stop="expand(!isExpanded)">
																	<v-icon :size="24" color="info">mdi-file-document</v-icon>
																</v-btn>
															</td>
															<td v-else-if="header.value === 'number'"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															:key="h">
																{{ index +1 }}
															</td>
															<td v-else-if="header.value == 'price'"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															 :key="h">
																{{ $eventBusUtility.headerValue(header.value, item) | currency }}
															</td>
															<td v-else-if="header.value === 'quantity'" :key="'quantity-'+h">
																<v-chip small color="grey darken-1" dark>
																	<v-icon small left>mdi-package-variant</v-icon>
																	{{ item.quantity }}
																</v-chip>
															</td>
															<td v-else-if="header.value === 'restore_quantity'" :key="'restored-'+h">
																<v-chip
																	small
																	:color="item.restore_quantity > 0 ? 'success' : 'grey lighten-1'"
																	:dark="item.restore_quantity > 0">
																	<v-icon small left>mdi-check-circle</v-icon>
																	{{ item.restore_quantity }}
																</v-chip>
															</td>
															<td v-else-if="header.value == 'quantity_to_restore'"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															width="200px"
															style="padding-right: 24px !important;" :key="h">
																<v-text-field
																	v-model.number="item.quantity_to_restore"
																	class="conversion-quantity"
																	label="Quantità"
																	type="number"
																	min="0"
																	hide-details
																	autofocus
																	dense
																	outlined
																	:error-messages="errors.collect('Quantità_'+item.id)"
																	v-validate="'required|min_value:0|max_value:'+getMaxDispatchable(item)"
																	:data-vv-name="'Quantità_'+item.id"
																	data-vv-as="Quantità"
																></v-text-field>
															</td>
															<td v-else-if="header.value === 'selected_lot_allocations'" :key="'lots-'+h">
																<conversion-lots-cell :item="item" quantity-key="quantity_to_restore"></conversion-lots-cell>
															</td>
															<td v-else :class="'text-xs-'+header.align" :key="h">
																{{ $eventBusUtility.headerValue(header.value, item) }}
															</td>
														</template>
													</tr>
												</template>
												<template v-slot:expanded-item="{ item, headers }">
													<tr>
									    				<td :colspan="headers.length" class="pa-0">
                                            				<v-card class="elevation-0">
																<v-card-text pa-4 v-html="item.description"></v-card-text>
															</v-card>
														</td>
													</tr>
												</template>
											</v-data-table>
											<v-divider></v-divider>
										</v-card>
									</v-col>
								</v-row>
								<v-row class="ma-0" justify="center">

									<v-col lg="3" md="3" sm="6">                            
										<v-list two-line class="background-2">
											<v-list-item>
												<v-list-item-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>Totale Quantità</v-list-item-title>
													<v-list-item-subtitle>{{ totalQuantity }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-col>
									<v-col lg="3" md="3" sm="6">
										<v-list two-line class="background-2">
											<v-list-item>
												<v-list-item-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>Totale Quantità convertita</v-list-item-title>
													<v-list-item-subtitle>{{ totalRestoreQuantity }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</v-list>       
									</v-col>
									<v-col lg="3" md="3" sm="6">
										<v-list two-line class="background-2">
											<v-list-item>
												<v-list-item-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>Totale Quantità da convertire</v-list-item-title>
													<v-list-item-subtitle>{{ totalQuantity - totalRestoreQuantity }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</v-list>       
									</v-col>

								</v-row>
							</v-container>
						</v-card>
					</v-col>
					<v-tooltip top>
                        <template v-slot:activator="{ on: tooltip }">
							<v-fab-transition>
								<v-btn
									v-on="{ ...tooltip }"
									@click.native="validateRestore()"
									:loading="saved"
									color="primary"
									dark
									fixed
									bottom
									right
									fab>
									<v-icon>input</v-icon>
								</v-btn>
							</v-fab-transition>
                        </template>
						<span>Evadi quantità</span>
					</v-tooltip>

					<confirm-dialog
						:confirmModel="confirmRestore"
						mainTitle="Vuoi convertire le quantità da te selezionate?"
						:secondTitle="customerReturn
							? 'Sarà creato un DDT di vendita di reso con le quantità scelte: la merce verrà caricata a magazzino'
							: 'Sarà creato un DDT di Acquisto con le quantità dei prodotti da te scelte'"
						@update:confirmModel="confirmRestore = false"
						:atConfirm="restoreDdt"
					></confirm-dialog>
                </v-tab-item>
            </v-tabs>
		</v-col>
	</v-row>
</template>

<script>
	import Vue from 'vue'
	import ConversionLotsCell from '@/components/common/ConversionLotsCell'
	import { missingSerials, conversionPayloadRows } from '@/components/common/conversionLots'

	export default {
		name: 'ddt-restore',
		components: { ConversionLotsCell },
		props: {
			id: Number,
			// reso da cliente come DDT di vendita (causale che carica) invece
			// del vecchio flusso che crea un DDT di acquisto
			customerReturn: Boolean,
		},
		
		data() {
			return {
				infos: {},
				models: {},
				relations: {},
				saved: false,
				processAll: false,
				confirmRestore: false,
				fieldsset: {},
				saleddt: {},
				defaultInput: {},
				// true solo mentre checkDefaultInput lancia le cascade dei valori d'origine
				applyingDefaultInput: false
			}
		},

		watch: {
			processAll: {
				handler(newValue, oldValue) {
					_.forEach(this.saleddt.products, (product) => {
						if(newValue) {
							Vue.set(product, 'quantity_to_restore', product.quantity - product.restore_quantity)
						} else {
							Vue.set(product, 'quantity_to_restore', 0)
						}
					})
				}
			}
		},

		computed: {
            
            totalQuantity() {
                return this.relations.products.collection.reduce((acc, product) => acc + product.quantity, 0);
            },

            totalRestoreQuantity() {
                return this.relations.products.collection.reduce((acc, product) => acc + product.restore_quantity, 0);
            }

        },

		created() {

			const infoUrl = this.customerReturn ? 'ddts-info-customer-return/' : 'ddts-info-restore/'
			this.axios.get(infoUrl + this.id).then(response => {
				// get body data
				this.infos = response.data.infos
                this.fieldsset = response.data.fields
				this.models = response.data.models
				this.relations = response.data.relations
				Vue.set(this.saleddt, 'products', this.relations.products.collection)
				if(!this.customerReturn) {
					this.saleddt.type = 'restore'
				}
				
				_.forEach(this.fieldsset.fields, (value, key) => {
					if(value.type === 'checkbox' || value.type === 'file') {
						Vue.set(this.saleddt, value.key, '')
					}
					if(value.default) {
						Vue.set(this.saleddt, value.key, value.default)
					}
				})
				_.forEach(this.saleddt.products, (product) => {
					Vue.set(product, 'quantity_to_restore', 0)
				})
				this.$store.commit('endProgress') 

				if(this.customerReturn) {
					// cliente, destinazione e causale dal DDT d'origine: checkDefaultInput
					// lancia anche le cascade, quindi aspetta che il form sia montato
					this.defaultInput = response.data.default_input || {}
					this.$nextTick(() => {
						this.applyingDefaultInput = true
						this.$eventBusUtility.checkDefaultInput(this, 'saleddt')
						this.applyingDefaultInput = false
					})
				}

			}, response => {
				// error callback
				this.$store.commit('endProgress')
				this.$router.back()
			})

		},

		methods: {

			roundNumber(num) {
				return Math.round(num * 100 + Number.EPSILON) / 100
			},

			getMaxDispatchable(item) {
				return this.roundNumber(item.quantity - item.restore_quantity)
			},

            // Call at change select option
            onChange(field, event) {
				// I valori d'origine (destinazione, progetto...) vanno rimessi dopo le cascade che checkDefaultInput
				// lancia all'apertura (quella dell'azienda li azzera); passati anche dopo, bloccherebbero i campi
				// derivati dall'azienda e riscriverebbero quelli cambiati a mano a ogni cascade successiva
				const defaultInput = this.applyingDefaultInput ? this.defaultInput : {}
				Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.saleddt, null, defaultInput)).then((responses) => {
                    responses.forEach(response => {
                        if(this.saleddt[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.saleddt[response.key])
                        }
                    })
                })
			},

			validateRestore() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}
					const missing = missingSerials(this.relations.products.collection, 'quantity_to_restore')
					if (missing.length) {
						this.$store.commit('setSnackbar', {
							timeout: 8000,
							text: 'Indica le matricole di: ' + missing.join(', '),
							value: true,
							color: 'error'
						})
						return false
					}
					this.confirmRestore = true
				}).catch(() => {

				})
			},
			
			restoreDdt() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}
					const url = this.customerReturn ? 'ddts-customer-return/' : 'ddts-restore/'
					const payload = Object.assign({}, this.saleddt, { products: conversionPayloadRows(this.saleddt.products) })
					this.axios.post(url + this.id, payload).then(response => {
						// get body data
						const showRoute = this.customerReturn ? 'ddts-show' : 'purchaseddts-show'
						this.$router.push({ name: showRoute, params: { id: parseInt(response.data.id) }})

					}, response => {
						// error callback
					});
				}).catch(() => {

				})
			},

		},
	}
</script>

<style>
	.no-max-height .v-data-table__wrapper {
		max-height: none !important;
	}
</style>